import { StepConfig } from '../../dynamicForm/types/fieldTypes';

// Mobile parity: Step 4 in the mobile flow is purely Location.
// Title/price/isNegotiable are entered in Step 1 and persisted in this step's
// backend call (which maps to the backend's `step: 3` payload).
export const detailsStep: StepConfig = {
  title: 'Location',
  description: 'Where is your vehicle?',
  sections: [
    {
      title: 'Vehicle Location',
      fields: [
        {
          name: 'county',
          type: 'select',
          label: 'County',
          required: true,
          layout: { span: 12 },
          resetFields: ['city'],
          api: {
            url: '/locations/counties',
            method: 'GET',
            mapResponse: (response: any[]) =>
              response.map((item) => ({ value: item.value, label: item.label })),
          },
          customProps: { placeholder: 'Select county' },
        },
        {
          name: 'city',
          type: 'select',
          label: 'City',
          required: true,
          layout: { span: 12 },
          api: {
            url: '/locations/cities',
            method: 'GET',
            params: (formData: Record<string, any>) => ({ county: formData.county }),
            dependencies: ['county'],
            mapResponse: (response: any[]) =>
              response.map((item) => ({ value: item.value, label: item.label })),
          },
          visible: (formData: Record<string, any>) => !!formData.county,
          customProps: { placeholder: 'Select city', helpText: 'Select a county first' },
        },
        {
          name: 'address',
          type: 'text',
          label: 'Full Address',
          required: true,
          layout: { span: 24 },
          customProps: { placeholder: 'Street, building, etc.' },
        },
      ],
    },
  ],
  footer: {
    buttons: [
      {
        label: 'Back',
        action: 'back',
        position: 'left',
        variant: 'secondary',
        icon: 'bi-arrow-left',
      },
      {
        label: 'Next: Contact',
        action: 'next',
        position: 'right',
        variant: 'primary',
        icon: 'bi-arrow-right',
      },
    ],
  },
};
